module.exports = __webpack_public_path__ + "img/9t.3b0cf2fc.jpg";